export class VacancyModifierHelper {
    static generateTagsInCities(data) {
        return data.map(vacancy => {
            vacancy.city = vacancy.city.map(c => {
                c.tags = [
                    {
                        name_ua: c.name_ua,
                        name_ru: c.name_ru
                    }
                ];
                return c;
            });
            return vacancy;
        });
    }
}
